// extracted by mini-css-extract-plugin
export default {"zoomModal":"l2-z"};